import React, { useState } from 'react'
import s from './CenteredIcon.module.css'
import Image from "next/legacy/image"


export interface CenteredIconProps {
  title?: string
  icon?: any
}

const CenteredIcon: React.FC<CenteredIconProps> = ((props) => {
  let {
    title,
    icon,
  } = props


  return (
    <div className={`${s.root} bg-neutral100`}>
      <div className={'text-center w-full'}>
        {icon && <div
          className='block md:inline-block w-full md:w-auto h-full block overflow-hidden relative'>
          <Image alt='Centered icon' src={icon} width={140} height={140} />
        </div>}
        <h3 className={'text-heading03Mobile md:text-heading01Mobile md:align-top md:mt-space8 w-e275 md:w-e336 inline-block mt-space6'}>{title}</h3>
      </div>
    </div>
  )
})

export default CenteredIcon
